<!--
 * @Author: linqiushu
 * @Date: 2020-12-28 09:50:15
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-06-25 14:37:44
-->
<template>
    <div>
        <div class="container">
			<div>
				<!-- <span class="reBack" :to="{path:'/main/notices'}">返回</span> -->
				<span class="reBack" @click="turnBack">返回</span>
			</div>
            <div v-if="errorMsg == ''">
                <div class="title">{{ notice.title }}</div>
                <div class="content" v-html="notice.content"></div>
            </div>
            <div v-else class="no_data">{{errorMsg}}</div>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    components: {},
    data() {
        return {
            notice:{},
            errorMsg:""
        }
    },
    created(){
        let id = this.$route.params.id;
        if(!id || id == ''){
            this.$tip.error("路径错误");
        }else{
            this.getData(id);
        }
    },
    methods: {
        getData(notice_id){
            this.errorMsg = "";
            this.$store.dispatch("main/getNoticeDetailById",{notice_id}).then(res => {
                if(res.flag == 1){
                    this.notice = res.data;
                }else{
                    this.errorMsg = res.msg;
                }
            })
        },
		// 返回
		turnBack(){
			this.$router.go(-1);
		}
    },
}
</script>
<style lang='scss' scoped>
.title{text-align: center;
    font-size: 20px;
    font-weight: bold;
    margin: 20px 0;
    color: #333;}
.content{border: 1px solid #dcdcdc;
    padding: 20px;
    min-height: calc(100% - 108px);}
.reBack{
		float: right;
		margin-top: 4px;
		font-size: 14px;
		color: #4da5f5;
		line-height: 13px;
		/* border-bottom:#4da5f5 solid 1px ; */
}
.reBack:hover{
	cursor: pointer;
	border-bottom:#4da5f5 solid 1px ;
}
</style>